import React, { useState } from 'react';
import { Box } from '@mui/material';
import ProjectList from '../components/projects/ProjectList';
import { useTranslation } from 'react-i18next';

function Projects() {
  const { t } = useTranslation();

  return (
    <Box sx={{ width: '100%' }}>
      <ProjectList />
    </Box>
  );
}

export default Projects;
